import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { api } from '../../services/baseUrl';
import MessageDetail from '../common/MessageDetail';
import { 
  Mail, 
  MessageSquare,
  X
} from 'lucide-react';

const MessagingAdmin = ({ isDark }) => {
  const [adminMessages, setAdminMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [replyText, setReplyText] = useState('');

  useEffect(() => {
    fetchAdminMessages();
  }, []);

  const fetchAdminMessages = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('access_token');
      const response = await api.get('/conversations', {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log('Messages admin reçus:', response.data);
      if (response.data.success && response.data.conversations) {
        setAdminMessages(response.data.conversations);
      } else {
        console.error('Erreur API:', response.data);
        if (response.data.error || response.data.message) {
          toast.error(response.data.error || response.data.message);
        }
        setAdminMessages([]);
      }
    } catch (error) {
      console.error('Erreur fetchAdminMessages:', error);
      toast.error('Erreur lors du chargement des messages');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      {selectedConversation ? (
        <div>
          <button
            onClick={() => setSelectedConversation(null)}
            className={`mb-4 px-4 py-2 rounded flex items-center gap-2 ${
              isDark ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'
            }`}
          >
            <X className="w-4 h-4" />
            Retour à la liste
          </button>
          <MessageDetail 
            conversation={selectedConversation}
            onBack={() => setSelectedConversation(null)}
            onUpdate={fetchAdminMessages}
          />
        </div>
      ) : (
        <>
          {/* Header */}
          <div className="mb-6">
            <h2 className="text-2xl font-bold mb-2 flex items-center gap-2">
              <Mail className="w-6 h-6" />
              Messages Reçus
            </h2>
            <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
              Gérez vos conversations avec les utilisateurs
            </p>
          </div>

      {/* Liste des conversations */}
      <div className={`rounded-lg ${isDark ? 'bg-gray-800' : 'bg-white'} shadow overflow-hidden`}>
        {loading ? (
          <div className="p-8 text-center">Chargement...</div>
        ) : adminMessages.length === 0 ? (
          <div className="p-8 text-center">
            <Mail className="w-12 h-12 mx-auto mb-3 opacity-30" />
            <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>Aucun message reçu</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className={isDark ? 'bg-gray-700' : 'bg-gray-100'}>
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-medium">Expéditeur</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">Dernier message</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">Messages</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">Non lus</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">Date</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {adminMessages.map(conv => (
                  <tr 
                    key={conv.conversation_id} 
                    className={`cursor-pointer ${isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}
                    onClick={() => setSelectedConversation(conv)}
                  >
                    <td className="px-4 py-3">
                      <div>
                        <div className="font-medium">
                          {conv.other_user?.firstname && conv.other_user?.lastname
                            ? `${conv.other_user.firstname} ${conv.other_user.lastname}`
                            : conv.other_user?.nickname || 'Utilisateur'}
                        </div>
                        <div className="text-xs text-gray-500">{conv.other_user?.email}</div>
                      </div>
                    </td>
                    <td className="px-4 py-3 max-w-md">
                      <div className="truncate text-sm">{conv.last_message?.content}</div>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className={`px-2 py-1 rounded text-xs ${isDark ? 'bg-blue-500/20 text-blue-300' : 'bg-blue-100 text-blue-800'}`}>
                        {conv.total_messages}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center">
                      {conv.unread_count > 0 && (
                        <span className="px-2 py-1 rounded-full text-xs font-bold bg-red-500 text-white">
                          {conv.unread_count}
                        </span>
                      )}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {new Date(conv.last_message?.created_at).toLocaleDateString('fr-FR', {
                        day: '2-digit',
                        month: 'short',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </td>
                    <td className="px-4 py-3">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedConversation(conv);
                        }}
                        className="text-blue-600 hover:text-blue-800"
                        title="Ouvrir"
                      >
                        <MessageSquare className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
        </>
      )}
    </div>
  );
};

export default MessagingAdmin;
